import React from 'react'
import NavBarHomeDark from '../../../components/NavBar/NavBarHomeDark'
import Breadcrumbs from '../../courses/Breadcrumbs'
import Footer from '../../../components/Footer/Footer'
import MainContent from './MainContent'
import AOSInit from '../../../components/Animation/AOSInit'

function BlogSingle() {
   return (
      <div className="pt-[70px] md:pt-[92px] flex flex-col min-h-screen bg-white dark:bg-dark-2">
         <AOSInit />
         <NavBarHomeDark />
         <section className="mb-8 md:mb-16 px-4">
            <Breadcrumbs />
         </section>

         <section className="mb-8 md:mb-16">
            <MainContent />
         </section>

         <section className="mt-auto">
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-dark-1 dark:bg-dark-6"
               textColor="text-gray-100 dark:text-gray-300"
               borderColor="border-gray-400/20 dark:border-gray-600/30"
            />
         </section>
      </div>
   )
}

export default BlogSingle